import {HttpClient} from '@angular/common/http';
import {UserUtil} from '../../../utils/UserUtil';
import {Scheduler} from '../../../utils/Scheduler';
import {Validator} from '../../../utils/Validator';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../service/user.service';
import {ApiServiceService} from '../../../api-service.service';
import {AnalyticsTracker} from '../../../utils/AnalyticsTracker';
import {Component, Input, OnChanges, OnInit, Type} from '@angular/core';
import {Keys, StorageService} from '../../../service/storage.service';
import {BasePhoneVerificationComponent} from '../../../phoneverification/base-phone-verification.component';
import {Step} from '../../../application-flow/steps/step';
import {PhoneVerificationStep} from '../../../application-flow/steps/phone-verification.step';
import {BrowserUtil} from '../../../utils/browser.util';

@Component({
    selector: 'app-phone-validator',
    templateUrl: './phone-validator.component.html',
    styleUrls: ['./phone-validator.component.css']
})
export class PhoneValidatorComponent extends BasePhoneVerificationComponent implements OnChanges, OnInit {
    @Input() public mobileNumber: string;
    @Input() public clearPhoneInfo: boolean;

    public otp: string;
    public errorMessage: string;
    public isUserCreated: boolean;
    public sendOtpLoader: boolean;
    public verifyOtpLoader: boolean;
    public readonly userUtil: UserUtil;
    private browserUtil: BrowserUtil;

    constructor(http: HttpClient, validator: Validator, ref: ApiServiceService, storageService: StorageService,
                scheduler: Scheduler, userService: UserService, router: Router, activatedRoute: ActivatedRoute,
                analyticsTracker: AnalyticsTracker, userUtil: UserUtil, browserUtil: BrowserUtil) {
        super(http, validator, ref, storageService, scheduler, userService, router, activatedRoute, analyticsTracker, null);
        this.userUtil = userUtil;
        this.browserUtil = browserUtil;
    }

    async ngOnInit(): Promise<void> {
        const token = this.storageService.getItem(Keys.TOKEN);
        if (token) {
            const userId = this.storageService.getItem('profile_id');
            const user = await this.userService.getUserPanAndContactInfo(userId, token);
            this.phoneNumber = user.mobile_no;
        }
    }

    ngOnChanges(): void {
        if (this.mobileNumber) {
            this.isReadonly = true;
            this.phoneNumber = this.mobileNumber;
        }
        if (this.clearPhoneInfo) {
            this.otp = '';
            this.showOtp = false;
            this.phoneNumber = '';
            this.mobileNumber = '';
            this.sendOtpLoader = false;
            this.verifyOtpLoader = false;
            this.isReadonly = false;
        }
    }

    async sendOtp(): Promise<void> {
        this.sendOtpLoader = true;
        await super.sendOtp();
    }

    async onPhoneVerificationFailed(error: any): Promise<void> {
        this.verifyOtpLoader = false;
        this.errorMessage = 'Please provide a valid OTP';
    }

    async onUserCreatedSuccessfully(): Promise<void> {
        this.isUserCreated = true;
        this.isReadonly = true;
        this.showOtp = false;
        this.fieldDisabledTag = true;
        this.verifyOtpLoader = false;
    }

    async onUserCreationFailed(): Promise<void> {
        this.verifyOtpLoader = false;
        this.errorMessage = 'Something went wrong while verifying OTP. Please try again.';
    }

    isUserOnline(): boolean {
        return this.browserUtil.isOnline();
    }

    step(): Type<Step> {
        return PhoneVerificationStep;
    }

    protected errorMessages(): object {
        throw new Error('Method not implemented.');
    }

    protected async verifyOtpAndCreateUser(otp: string): Promise<void> {
        this.errorMessage = '';
        this.verifyOtpLoader = true;
        await super.verifyOtpAndCreateUser(otp);
    }

    protected onOtpSentSuccessfully(phoneVerificationToken: string): void {
        super.onOtpSentSuccessfully(phoneVerificationToken);
        this.sendOtpLoader = false;
    }
}
